// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1Kheu","savePackageButton":"ClientWallet_savePackageButton__2HdUD"};